import React, { useMemo, useState } from "react";
import OverviewView from "./OverView";

function SuperAdminPortal() {
  
  const [view, setView] = useState("overview");
  // Local state so admin can approve / reject / toggle etc.
  const [retailerList, setRetailerList] = useState();
  const [agentList] = useState();
  const [warrantyList] = useState();
  const [claimList, setClaimList] = useState();
  const [payoutList, setPayoutList] = useState();
  const [taskList, setTaskList] = useState();
  const [legalList] = useState();
  const [retailerUserList, setRetailerUserList] = useState();

  // Admin actions – users & retailers 
  const handleToggleUserStatus = (id) => {
    setRetailerUserList((prev) =>
      prev.map((u) =>
        u.id === id
          ? {
              ...u,
              status: u.status === "Active" ? "Inactive" : "Active",
            }
          : u
      )
    );
  };

  const handleToggleRetailerStatus = (id) => {
    setRetailerList((prev) =>
      prev.map((r) =>
        r.id === id
          ? {
              ...r,
              status: r.status === "Active" ? "Deactivated" : "Active",
            }
          : r
      )
    );
  };

  // Admin actions – tasks
  const handleAddTask = (task) => {
    setTaskList((prev) => {
      const nextIndex = prev.length + 101;
      return [
        ...prev,
        {
          ...task,
          id: task.id || `TSK-${nextIndex}`,
        },
      ];
    });
  };

  const handleUpdateTask = (id, updates) => {
    setTaskList((prev) => prev.map((t) => (t.id === id ? { ...t, ...updates } : t)));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-slate-100 flex flex-col text-slate-900">
      
      {/* Content */}
      <main className="flex-1 px-2 md:px-4 py-2">
        {view === "overview" && <OverviewView  />}
      </main>
    </div>
  );
}

export default SuperAdminPortal;
